module.exports = __webpack_public_path__ + "img/NormalMap.01d93dd7.png";